import { render, staticRenderFns } from "./YouthStudy.vue?vue&type=template&id=5758e519&"
import script from "./YouthStudy.vue?vue&type=script&lang=js&"
export * from "./YouthStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports